// extracted by mini-css-extract-plugin
export default {"wrapper":"r8R2H","wrapper__image":"sjECw"};